import {
	GET_SITES_CUSTOMER,
	SET_SELECTED_SITE,
	IS_LOADING,
} from "./customerSiteConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { ALL_SELECT_OPTION } from "../../constants";
import { tryParseInt } from "../../utils";

export function getSitesCustomerAction(sites) {
	return {
		type: GET_SITES_CUSTOMER,
		sites,
	};
}

export function setSelectedSiteAction(selectedSite) {
	return {
		type: SET_SELECTED_SITE,
		selectedSite,
	};
}

export function siteCustomerIsLoading(value) {
	return {
		type: IS_LOADING,
		info: "Site",
		isLoading: value,
	};
}

export function setSelectedSite(selectedSiteId) {
	return (dispatch) => {
		localStorage.setItem("selectedSiteId", selectedSiteId);
		dispatch(setSelectedSiteAction(selectedSiteId));
	};
}

export function getSites(userId) {
	return dispatch => {
		const headers = new Headers({ "Content-Type": "application/json" });
		dispatch(siteCustomerIsLoading(true));

		fetchWithTimeout(
			"/api/v1/siteCustomer/get_sites_customer/" + userId,
			{
				method: "GET",
				headers: headers,
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw Error(response.statusText);
				}

				return response;
			})
			.then((response) => response.json())
			.then((sites) => {

				sites = sites[userId];

				dispatch(getSitesCustomerAction(sites));

				let selectedSiteId = tryParseInt(localStorage.getItem("selectedSiteId"), 0)

				if (sites.length > 0 && !selectedSiteId)
					selectedSiteId = sites[0].id
				else if (sites.length <= 0 || sites.find(s => s.id === selectedSiteId) === null)
					selectedSiteId = 0

				dispatch(setSelectedSite(selectedSiteId));
				dispatch(siteCustomerIsLoading(false));
			})
			.catch((err) => {
				console.error(
					"Erreur : customerSiteActions - getSites",
					err
				);

				dispatch(
					throwErrorMessage({
						errorObject: err,
						title: "Erreur",
						message: "Erreur lors de la récupération des sites !",
					})
				);

				dispatch(siteCustomerIsLoading(false));
			});
	}
}

export function getSiteIds(customerSiteId, allSites) {
	if (customerSiteId === ALL_SELECT_OPTION)
		customerSiteId = allSites.map(s => s.id);
	else
		customerSiteId = [customerSiteId];

	return customerSiteId;
}